import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-dashed-content',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dashed-content.component.html',
  styleUrls: ['./dashed-content.component.css'],
})
export class DashedContentComponent {
  @Input() highlight!: boolean;
}
